<common-activity-type-base [activity]="activity">
  <div class="w-50 mt-5 mx-auto" *ngIf="!loaded">
    <common-spinner-loader></common-spinner-loader>
  </div>
  <div *ngIf="loaded">
    <p class="fs-18">Renter Details</p>
    <dl class="row">
      <dt class="col-sm-3 font-weight-bold">Account Verification Status</dt>
      <dd class="col-sm-9">{{ renterAccount.verificationStatus }}</dd>

      <dt class="col-sm-3 font-weight-bold">Renter</dt>
      <dd class="col-sm-9">
        <a target="_blank" [routerLink]="['/account/items', renter.accountId, 'users', renter.userId]"><i class="icon-listing mr-2"></i>{{ renter.name }}</a>
      </dd>

      <dt class="col-sm-3 font-weight-bold">Account</dt>
      <dd class="col-sm-9">
        <a target="_blank" [routerLink]="['/account/items', renter.accountId]"><i class="icon-listing mr-2"></i>{{ renter.accountName }}</a>
      </dd>

      <dt class="col-sm-3 font-weight-bold">COI Task</dt>
      <dd class="col-sm-9">{{ accountActivity("COI")?.status || "Error occured" }}</dd>

      <dt class="col-sm-3 font-weight-bold">Drivers License Task</dt>
      <dd class="col-sm-9">{{ accountActivity("DRIVERS-LICENSE")?.status || "Error occured" }}</dd>

      <dt class="col-sm-3 font-weight-bold">Selfie Task</dt>
      <dd class="col-sm-9">{{ accountActivity("SELFIE")?.status || "Error occured" }}</dd>

      <dt class="col-sm-3 font-weight-bold"></dt>
      <dd class="col-sm-9">
        <a target="_blank" [routerLink]="['/account/items', renter.accountId, 'activities']"><i class="icon-listing mr-2"></i>View Tasks</a>
      </dd>
    </dl>
    <div class="bb-light my-3"></div>
    <p class="fs-18">Order Stats</p>
    <dl class="row">
      <dt class="col-sm-3 font-weight-bold">Pending</dt>
      <dd class="col-sm-9">{{ orderStats.pending }}</dd>
      <dt class="col-sm-3 font-weight-bold">In Progress</dt>
      <dd class="col-sm-9">{{ orderStats.inProgress }}</dd>
      <dt class="col-sm-3 font-weight-bold">Complete</dt>
      <dd class="col-sm-9">{{ orderStats.complete }}</dd>
      <dt class="col-sm-3 font-weight-bold">Cancelled</dt>
      <dd class="col-sm-9">{{ orderStats.cancelled }}</dd>
    </dl>
    <div class="bb-light my-3"></div>
    <p class="fs-18">Jobsite Location</p>
    <div [innerHTML]="jobsiteLocation"></div>
    <div class="bb-light my-3"></div>
    <ng-container *ngIf="activity.status == 'Open'">
      <p class="fs-18">I have verified the following</p>
      <div class="form-group mt-3" *ngFor="let term of terms">
        <div class="d-flex align-items-center mr-5">
          <app-input-checkbox [label]="term.label" [(checked)]="term.checked" [large]="true" [invalid]="false" [useHtml]="true"> </app-input-checkbox>
          <app-questionmark-tooltip *ngIf="term.tooltip" class="ml-2" [displayLearnMore]="false" [text]="term.tooltip" mobilePlacement="left">
          </app-questionmark-tooltip>
        </div>
      </div>
      <button type="button" class="btn btn-success btn-block btn-modal-footer" (click)="save(true)" [disabled]="disableButton">Submit</button>
      <button type="button" class="btn btn-danger btn-block btn-modal-footer mt-3" (click)="save(false)">Renter is not verified</button>
    </ng-container>

    <ng-container *ngIf="activity.status == 'Closed'">
      <div class="fs-18">Is the renter verified?</div>
      <div class="font-weight-light">{{ activity.activityResponse == "true" ? "Yes" : "No" }}</div>

      <div class="fs-18 mt-3"></div>
      <div class="font-weight-light mb-3" *ngFor="let term of activity.metadata.terms" [innerHtml]="term.label"></div>
    </ng-container>
  </div>
</common-activity-type-base>
